import { render, staticRenderFns } from "./NewsInfo.vue?vue&type=template&id=5fefa428&scoped=true&"
import script from "./NewsInfo.vue?vue&type=script&lang=js&"
export * from "./NewsInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewsInfo.vue?vue&type=style&index=0&id=5fefa428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fefa428",
  null
  
)

export default component.exports